import { render, staticRenderFns } from "./TenantCustomShow.vue?vue&type=template&id=0cf428c4&scoped=true&"
import script from "./TenantCustomShow.vue?vue&type=script&lang=js&"
export * from "./TenantCustomShow.vue?vue&type=script&lang=js&"
import style0 from "./TenantCustomShow.vue?vue&type=style&index=0&id=0cf428c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf428c4",
  null
  
)

export default component.exports